import { SM } from './storeModel.enum';
import { UiMode } from './uiMode';
import { ThemeConfig } from './themeConfig';
import { SAASBRANDNAME } from './saasBrandName.enum';
import { EventTracker } from './eventTracker';

export const SidebarMenu = [
  {
    order: 0,
    type: 'item_left',
    label: 'navbar.item0',
    iconClass: 'fa-solid fa-gauge',
    hrefLink: null,
    routerLink: '/auth/dashboard',
    storeModel: SM.SM_DASHBOARD,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'dashboard',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_DASHBOARD,
    livestockEventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_DASHBOARD,
  },
  {
    order: 1,
    type: 'item_left',
    label: 'navbar.item1',
    iconClass: 'fa-kit fa-fields',
    hrefLink: null,
    routerLink: '/auth/fields',
    storeModel: SM.SM_FIELD,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'main',
    dataCy: 'fields',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_FIELDS,
  },
  {
    order: 1,
    type: 'item_left',
    label: 'navbar.stables',
    iconClass: 'fa-kit fa-stables',
    hrefLink: null,
    routerLink: '/auth/stables',
    storeModel: SM.SM_STABLE,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'stables',
    eventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_BARNS,
  },
  {
    order: 2,
    type: 'item_left',
    label: 'navbar.animals',
    iconClass: 'fa-kit fa-livestock',
    hrefLink: null,
    routerLink: '/auth/animals',
    storeModel: SM.SM_ANIMAL,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
    menuGroup: 'main', //TODO
    dataCy: 'animals',
    eventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_ANIMALS,
  },
  {
    order: 2,
    type: 'item_left',
    label: 'navbar.item3',
    iconClass: 'fa-kit fa-activity',
    hrefLink: null,
    routerLink: '/auth/stable-activity',
    storeModel: SM.SM_STABLEACTIVITY,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'stable-activity',
    eventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_ACTIVITIES,
  },
  {
    order: 2,
    type: 'item_left',
    label: 'navbar.item2',
    iconClass: 'fa-kit fa-custom-map',
    hrefLink: null,
    routerLink: '/auth/map',
    storeModel: SM.SM_MAP,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'map',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_MAP,
    livestockEventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_MAP,
  },
  {
    order: 3,
    type: 'item_left',
    label: 'navbar.item3',
    iconClass: 'fa-kit fa-activity',
    hrefLink: null,
    routerLink: '/auth/activities',
    storeModel: SM.SM_FIELDACTIVITY,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'main',
    dataCy: 'activities',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_ACTIVITIES,
  },
  {
    order: 4,
    type: 'item_left',
    label: 'navbar.weather',
    iconClass: 'fa-kit fa-weather',
    hrefLink: null,
    routerLink: '/auth/weather',
    storeModel: SM.SM_WEATHER_FREE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'agronomy',
    dataCy: 'weather',
    eventTrackerName: EventTracker.CLICK_MENU_WEATHER,
  },
  {
    order: 5,
    type: 'item_left',
    label: 'navbar.item4',
    iconClass: 'fa-kit fa-sensors',
    hrefLink: null,
    routerLink: '/auth/sensors',
    storeModel: SM.SM_SENSOR,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'agronomy',
    dataCy: 'sensors',
    eventTrackerName: EventTracker.CLICK_MENU_SENSORS,
  },
  {
    order: 6,
    type: 'item_left',
    label: 'navbar.nutrition',
    iconClass: 'fa-kit fa-nutrition',
    hrefLink: null,
    routerLink: '/auth/nutrition/dashboard',
    storeModel: SM.SM_NUTRITION_FREE,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'agronomy',
    dataCy: 'nutrition',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_NUTRITION,
  },
  {
    order: 7,
    type: 'item_left',
    label: 'navbar.item6_1',
    iconClass: 'fa-kit fa-custom-warehouse',
    hrefLink: null,
    routerLink: '/auth/containers',
    storeModel: SM.SM_WAREHOUSE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'containers',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_WAREHOUSES,
    livestockEventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_WAREHOUSES,
  },
  {
    order: 8,
    type: 'item_left',
    label: 'navbar.item5',
    iconClass: 'fa-solid fa-note-sticky',
    hrefLink: null,
    routerLink: '/auth/notes',
    storeModel: SM.SM_NOTE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'management',
    dataCy: 'notes',
    eventTrackerName: EventTracker.CLICK_MENU_NOTES,
  },
  {
    order: 9,
    type: 'item_left',
    label: 'navbar.products',
    iconClass: 'fa-kit fa-product',
    hrefLink: null,
    routerLink: '/auth/products',
    storeModel: SM.SM_PRODUCT,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'products',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_PRODUCTS,
    livestockEventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_PRODUCTS,
  },
  {
    order: 10,
    type: 'item_left',
    label: 'navbar.item6_2',
    iconClass: 'fa-kit fa-loads',
    hrefLink: null,
    routerLink: '/auth/loads',
    storeModel: SM.SM_LOAD,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'main',
    dataCy: 'loads',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_LOADS,
  },
  {
    order: 10,
    type: 'item_left',
    label: 'navbar.item6_2',
    iconClass: 'fa-kit fa-loads',
    hrefLink: null,
    routerLink: '/auth/stable-loads/list',
    storeModel: SM.SM_STABLE_LOAD,
    children: null,
    enableModeList: [UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'stable-loads',
    eventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_LOADS,
  },
  {
    order: 11,
    type: 'item_left',
    label: 'navbar.item6_6',
    iconClass: 'fa-kit fa-silos',
    hrefLink: null,
    routerLink: '/auth/silos',
    storeModel: SM.SM_SILOS,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'silos',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_SILOS,
    livestockEventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_SILOS,
  },
  {
    order: 12,
    type: 'item_left',
    label: 'navbar.item6_3',
    iconClass: 'fa-kit fa-machinery',
    hrefLink: null,
    routerLink: '/auth/equipments',
    storeModel: SM.SM_EQUIPMENT,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'machinery',
    dataCy: 'equipments',
    eventTrackerName: EventTracker.CLICK_MENU_MACHINERY,
  },
  {
    order: 13,
    type: 'item_left',
    label: 'navbar.cropPlanning',
    iconClass: 'fa-kit fa-activity',
    hrefLink: null,
    routerLink: '/auth/crop-planning',
    storeModel: SM.SM_CROP_PLANNING,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'crop-planning',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_CROP_PLANNING,
  },
  {
    order: 14,
    type: 'item_left',
    label: 'navbar.batchs',
    iconClass: 'fas fa-archive',
    hrefLink: null,
    routerLink: '/auth/batchs',
    storeModel: SM.SM_BATCH,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'batchs',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_PRODUCTION_BATCHES,
  },
  {
    order: 15,
    type: 'item_left',
    label: 'navbar.item11',
    iconClass: 'fas fa-chalkboard-teacher',
    hrefLink: null,
    routerLink: '/auth/training',
    storeModel: SM.SM_ROLES_ACCESS,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'main',
    dataCy: 'training',
    eventTrackerName: EventTracker.CLICK_MENU_COMMUNICATIONS,
  },
  {
    order: 16,
    type: 'item_left',
    label: 'navbar.item9',
    iconClass: 'fa-kit fa-custom-satellite',
    hrefLink: null,
    routerLink: '/auth/satellite',
    storeModel: SM.SM_SATELLITE_FREE,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'machinery',
    dataCy: 'satellite',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_SATELLITE,
  },
  {
    order: 17,
    type: 'item_left',
    label: 'navbar.analysis',
    iconClass: 'fa-solid fa-map',
    hrefLink: null,
    routerLink: '/auth/satellite/manage-files',
    storeModel: SM.SM_PRECISIONFARMING,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'machinery',
    dataCy: 'analysis',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_ANALYSIS,
  },
  {
    order: 18,
    type: 'item_left',
    label: 'navbar.item6_5',
    iconClass: 'glyphicon glyphicon-bell',
    hrefLink: null,
    routerLink: '/auth/alerts/list',
    storeModel: SM.SM_ALERT,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'management',
    dataCy: 'alerts',
    eventTrackerName: EventTracker.CLICK_MENU_ALERTS,
  },
  {
    order: 19,
    type: 'item_left',
    label: 'navbar.irrigating',
    iconClass: 'fa-solid fa-droplet',
    hrefLink: null,
    routerLink: '/auth/irrigation',
    storeModel: SM.SM_IRRIGATION,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'agronomy',
    dataCy: 'irrigation',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_IRRIGATION,
  },
  {
    order: 20,
    type: 'item_left',
    label: 'navbar.financial',
    iconClass: 'fa-solid fa-coins',
    hrefLink: null,
    routerLink: '/auth/financials',
    storeModel: SM.SM_FINANCE,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'finances',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_FINANCES,
  },
  {
    order: 21,
    type: 'item_left',
    label: 'navbar.diseases',
    iconClass: 'fa-solid fa-shield-halved',
    hrefLink: null,
    routerLink: '/auth/diseases',
    storeModel: SM.SM_PATHOGEN,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'agronomy',
    dataCy: 'pathogens',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_PATHOGENS,
  },
  {
    order: 22,
    type: 'item_left',
    label: 'navbar.overview',
    iconClass: 'fa-solid fa-gauge',
    hrefLink: null,
    routerLink: '/auth/overview',
    storeModel: SM.SM_ANALYTICS_OVERVIEW,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'main',
    dataCy: 'overview',
    eventTrackerName: null,
  },
  {
    order: 23,
    type: 'item_left',
    label: 'navbar.chain-management',
    iconClass: 'fas fa-chart-line',
    hrefLink: null,
    routerLink: '/auth/chain-management',
    storeModel: SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'main',
    dataCy: 'chain-management',
    eventTrackerName: null,
  },
  {
    order: 24,
    type: 'item_left',
    label: 'navbar.impact',
    iconClass: 'fa-solid fa-hand-holding-seedling',
    hrefLink: null,
    routerLink: '/auth/sustainability-analytics',
    storeModel: SM.SM_ANALYTICS_IMPACT,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'sustainability',
    dataCy: 'sustainability',
    eventTrackerName: null,
  },
  {
    order: 25,
    type: 'item_left',
    label: 'navbar.operationsManagement',
    iconClass: 'fa-kit fa-operational',
    hrefLink: null,
    routerLink: '/auth/operation-management',
    storeModel: SM.SM_OPERATION_MANAGEMENT,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'operation-management',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_OPERATION_MANAGEMENT,
  },
  {
    order: 30,
    type: 'item_left',
    label: 'navbar.farm_dossier',
    iconClass: 'fas fa-book',
    hrefLink: null,
    routerLink: '/auth/farm-dossier/dash-board',
    storeModel: SM.SM_FARM_DOSSIER,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'management',
    eventTrackerName: null,
  },
  {
    order: 26,
    type: 'item_left',
    label: 'navbar.taskplan',
    iconClass: 'fa-solid fa-calendar-days',
    hrefLink: null,
    routerLink: '/auth/task-plan',
    storeModel: SM.SM_WORK_PLANNING,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'task-plan',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_TASK_PLAN,
  },
  {
    order: 27,
    type: 'item_left',
    label: 'navbar.agrirouter',
    iconClass: 'fa-solid fa-route',
    hrefLink: null,
    routerLink: '/auth/task-viewer',
    storeModel: SM.SM_EQUIPMENT_TELEMETRY,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'machinery',
    dataCy: 'task-viewer',
    eventTrackerName: EventTracker.CLICK_MENU_TASK_VIEWER,
  },
  {
    order: 28,
    type: 'item_left',
    label: 'navbar.farm_sustainability',
    iconClass: 'fa-solid fa-hand-holding-seedling',
    hrefLink: null,
    routerLink: '/auth/sustainability/dashboard',
    storeModel: SM.SM_SUSTAINABILITY,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'sustainability-farm',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_SUSTAINABILITY,
  },
  {
    order: 29,
    type: 'item_left',
    label: 'navbar.insects',
    iconClass: 'fa-kit fa-insects',
    hrefLink: null,
    routerLink: '/auth/insects',
    storeModel: SM.SM_INSECTS,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'agronomy',
    dataCy: 'insects',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_INSECTS,
  },
  {
    order: 30,
    type: 'item_left',
    label: 'navbar.export_document',
    iconClass: 'fas fa-cloud-download-alt',
    hrefLink: null,
    routerLink: '/auth/import-export/export',
    storeModel: SM.SM_EXPORT_FREE,
    children: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    menuGroup: 'miscellaneous',
    dataCy: 'export-page',
    eventTrackerName: EventTracker.CLICK_MENU_EXPORT_DOCUMENTS,
  },
  {
    order: 33,
    type: 'item_left',
    label: 'navbar.checks',
    iconClass: 'fa-solid fa-file-circle-check',
    hrefLink: null,
    routerLink: '/auth/checks',
    storeModel: SM.SM_CHECKS,
    children: null,
    enableModeList: [UiMode.FARM],
    menuGroup: 'management',
    dataCy: 'checks',
    eventTrackerName: EventTracker.CLICK_AGRO_MENU_CHECKS,
  },
  {
    order: 30,
    type: 'dropdown_right',
    label: null,
    iconClass: 'glyphicon glyphicon-user',
    routerLink: null,
    storeModel: null,
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    dataCy: 'userName',
    children: [
      {
        order: 0,
        type: 'item_left',
        label: 'navbar.item7_3',
        iconClass: 'fa fa-question-circle',
        hrefLink: 'https://www.xfarm.ag/tutorials/',
        routerLink: null,
        storeModel: SM.SM_GUIDE,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
        dataCy: 'guide',
        eventTrackerName: EventTracker.CLICK_MENU_TUTORIAL,
      },
      {
        order: 1,
        type: 'item_left',
        label: 'navbar.item7_1w',
        iconClass: 'fa-kit fa-product',
        hrefLink: null,
        routerLink: '/auth/welcome/farm',
        storeModel: null,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
        dataCy: 'welcome',
        eventTrackerName: EventTracker.CLICK_TOP_BAR_ACCOUNT_COMPANY,
      },
      {
        order: 2,
        type: 'item_left',
        label: 'navbar.item7_1',
        iconClass: 'fa-kit fa-settings',
        hrefLink: null,
        routerLink: '/auth/company-data',
        storeModel: SM.SM_SETTING,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
        dataCy: 'company-data',
        eventTrackerName: EventTracker.CLICK_MENU_SETTINGS,
      },
      {
        order: 3,
        type: 'item_left',
        label: 'navbar.shared',
        iconClass: 'fas fa-share-square',
        hrefLink: null,
        routerLink: '/auth/sharing',
        storeModel: SM.SM_SETTING,
        children: null,
        enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
        dataCy: 'sharing',
        eventTrackerName: null,
      },
    ],
  },
  {
    order: 31,
    type: 'item_left',
    label:
      ThemeConfig.brand !== SAASBRANDNAME.BARILLA &&
      ThemeConfig.brand !== SAASBRANDNAME.ANALYTICSBARILLA
        ? 'navbar.chain_document'
        : 'contractManagement.title',
    iconClass: 'fas fa-file-contract',
    hrefLink: null,
    routerLink: '/auth/contract-management/dashboard',
    storeModel: SM.SM_CONTRACT_MANAGEMENT,
    children: null,
    menuGroup: 'services',
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    dataCy: 'contract-management',
    eventTrackerName: EventTracker.CLICK_MENU_AGRO_CONTRACTS,
  },
  {
    order: 32,
    type: 'item_left',
    label: 'navbar.audit',
    iconClass: 'fas fa-search',
    hrefLink: null,
    // TODO: make dashboard as default road when the page will be ready
    // routerLink: '/auth/audit/dashboard',
    routerLink: '/auth/audit',
    storeModel: SM.SM_CONTRACT_AUDIT,
    children: null,
    menuGroup: 'services',
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    dataCy: 'management',
    eventTrackerName: null,
  },
  {
    order: 33,
    type: 'item_left',
    label: 'navbar.rations',
    iconClass: 'fa-kit fa-ration',
    hrefLink: null,
    routerLink: '/auth/rations',
    storeModel: SM.SM_RATIONS,
    children: null,
    menuGroup: 'agronomy',
    enableModeList: [UiMode.LIVESTOCK],
    dataCy: 'rations',
    eventTrackerName: EventTracker.CLICK_LIVESTOCK_MENU_RATIONS,
  },
  //COMMENTED MODULE --> requested XFARMDEV-14852
  // {
  //     order: 34,
  //     type: 'item_left',
  //     label: 'navbar.crop_map',
  //     iconClass: 'fab fa-pagelines',
  //     hrefLink: null,
  //     routerLink: '/auth/crop-map',
  //     storeModel: SM.SM_CROP_MAP,
  //     children: null,
  //     menuGroup: "management",
  //     enableModeList: [UiMode.FARM]
  // },
  {
    order: 35,
    type: 'item_left',
    label: 'navbar.item11',
    iconClass: 'fas fa-chalkboard-teacher',
    hrefLink: null,
    routerLink: '/auth/education/post/list',
    storeModel: SM.SM_EDUCATION_EDITOR,
    children: null,
    menuGroup: 'management',
    enableModeList: [UiMode.FARM],
    eventTrackerName: null,
  },
  {
    order: 36,
    type: 'item_left',
    label: 'navbar.xsurvey',
    iconClass: 'fa-solid fa-list-check',
    hrefLink: null,
    routerLink: '/auth/survey',
    storeModel: SM.SM_SURVEY,
    children: null,
    menuGroup: 'services',
    enableModeList: [UiMode.FARM, UiMode.LIVESTOCK],
    dataCy: 'services',
    eventTrackerName: null,
  },
  {
    order: 37,
    type: 'item_left',
    label: 'regenerative.title',
    iconClass: 'fa-solid fa-seedling',
    hrefLink: null,
    routerLink: '/auth/regenerative/protocols',
    storeModel: SM.SM_ANALYTICS_REGENERATIVE,
    children: null,
    menuGroup: 'sustainability',
    enableModeList: [UiMode.FARM],
    dataCy: 'sustainability',
  },
];

export const MenuGroupAnalytics = [
  { name: 'main', icon: 'fa-solid fa-chart-simple' },
  { name: 'sustainability', icon: 'fa-solid fa-hand-holding-seedling' },
  { name: 'management', icon: 'fa-solid fa-chart-gantt' },
  { name: 'services', icon: 'fa-kit fa-insurance' },
];
